var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('link',{attrs:{"rel":"stylesheet","type":"text/css","href":"https://cdn-prod.securiti.ai/consent/cookie-consent.css"}}),_c('v-btn',{staticClass:"cmp-revoke-consent",attrs:{"color":"secondary"}},[_vm._v(" Rever Cookies ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }